import { render, staticRenderFns } from "./ContractValues.vue?vue&type=template&id=0081e462"
import script from "./ContractValues.vue?vue&type=script&lang=js"
export * from "./ContractValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports